import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Layout from "../../components/Layout/Default";
import Footer from "../../components/Partials/Footer";
import Header from "../../components/Partials/Header";
import { getCaso } from "../../assets/js/api";
import { translate } from "../../assets/js/functions";
import { domain } from "../../assets/js/api";
import fotoPlaceHolder from "../../assets/img/placeholder@2x.jpg";

export default function Ficha() {
    const { section_id } = useParams();
    const [caso, setCaso] = useState(null);

    useEffect(() => {
        getCaso(section_id).then((caso) => {
            setCaso(caso);
        });
    }, []);

    return (
        <Layout pageMeta={{}}>
            <div className="page-container py-5 is-flex is-flex-direction-column">
                <Header />
                <main id="main" className="is-relative mb-7">

                    <p className="px-6 mb-6">
                        <Link to="/otros-funcionarios-represaliados/" className="is-inline-flex is-size-7 is-align-items-center has-text-black link-dn">
                            <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg">
                                <g fill="none" fillRule="evenodd">
                                    <path d="M0 0h30v30H0z" />
                                    <path stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M6.25 15h17.5M6.25 15l5 5M6.25 15l5-5" />
                                </g>
                            </svg>{translate("Volver a Otros funcionarios represaliados")}
                        </Link>
                    </p>
                    {caso && (
                        <div className="wrapper flow--xl">
                            <div className="columns is-flex-direction-row-reverse is-variable is-8">
                                <div className="column flow--xl">
                                    <div className="flow--2xs">

                                        <h1>{caso.term}</h1>
                                    </div>
                                    <div className="columns is-desktop is-variable is-6">
                                        <div className="column flow--l">
                                            <ul className="links-list flow--l">
                                                {caso.fichaOroibidea && (
                                                    <li>
                                                        <a href={caso.fichaOroibidea} target="_blank" rel="noopener noreferrer">
                                                            {translate("Ficha en Oroibidea")}

                                                        </a>
                                                    </li>
                                                )}
                                                {caso.fichaUPNA && (
                                                    <li>
                                                        <a href={caso.fichaUPNA} target="_blank" rel="noopener noreferrer">
                                                            {translate("Ficha en la UPNA")}
                                                        </a>
                                                    </li>
                                                )}
                                                {(caso.pdf_resolved || caso.linkBiografia) && (
                                                    <li>
                                                        <a
                                                            href={
                                                                caso.pdf_resolved
                                                                    ? domain + JSON.parse(caso.pdf_resolved)[0]
                                                                    : caso.linkBiografia
                                                            }
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {translate("Biografía")}
                                                        </a>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                        <div className="column"></div>
                                    </div>
                                </div>
                                <div className="column is-narrow">
                                    {caso && caso.image && Array.isArray(caso.image) && caso.image.length > 0 && caso.image[0].image ? (
                                        <img
                                            loading="lazy"
                                            src={domain + caso.image[0].image}
                                            alt=""
                                            width="252"
                                            height="287"
                                        />
                                    ) : (
                                        <img
                                            loading="lazy"
                                            src={fotoPlaceHolder}
                                            alt=""
                                            width="252"
                                            height="287"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>

                    )}


                </main>
                <Footer />
            </div>
        </Layout >
    );
}